import { render, staticRenderFns } from "./preformatted-editor-action-text-templates.vue?vue&type=template&id=3c56c80f&scoped=true&"
import script from "./preformatted-editor-action-text-templates.ts?vue&type=script&lang=ts&"
export * from "./preformatted-editor-action-text-templates.ts?vue&type=script&lang=ts&"
import style0 from "./preformatted-editor-action-text-templates.scss?vue&type=style&index=0&id=3c56c80f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c56c80f",
  null
  
)

export default component.exports